module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./WorkPrivateAuthView.js"));
	}, "WorkPrivateAuthView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=WorkPrivateAuthView!./src/pages/Shop/WechatAuth/WorkPrivateAuth/WorkPrivateAuthView.js
// module id = 908
// module chunks = 431